import * as React from 'react'
import {
  BannerSectionContainer,
  BannerSectionSubtitle,
  BannerSectionTitle,
  BannerSectionWrapper
} from './BannerSection.elements'

export type BannerSectionProps = {
  title: string,
  subtitle: string,
}

export const BannerSection: React.FunctionComponent<BannerSectionProps> = ({title, subtitle}) => (
  <BannerSectionContainer>
    <BannerSectionWrapper>
      <BannerSectionTitle dangerouslySetInnerHTML={{__html: title}}/>
      <BannerSectionSubtitle dangerouslySetInnerHTML={{__html: subtitle}}/>
    </BannerSectionWrapper>
  </BannerSectionContainer>
)
